module.exports = __webpack_public_path__ + "img/ES0121.ddae0991.png";